import http from "../../../core/services/http.service";

const TemplatesService = {
  getTemplates(params = null, expand = '') {
    return http.get(`/api/v1/templates/?expand=${expand}`, {params});
  },
  updateTemplate(id, data, expand = '') {
    return http.put(`/api/v1/templates/${id}/?expand=${expand}`, data);
  },
  removeTemplate(uuid) {
    return http.delete(`/api/v1/templates/${uuid}/`)
  },
  createTemplate(data) {
    return http.post('/api/v1/templates/', data);
  },
}

export default TemplatesService;
